/* SOLIKKA-DTC-REBUILD interactions. Progressive enhancement: content works without JS. */
(function () {
  if (window.__slkInit) return; window.__slkInit = true;
  document.documentElement.classList.add('slk-js');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  window.slkMoney = money;

  /* Toast */
  var toast;
  function say(msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'slk-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = msg; toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  /* Cart: add items, then notify theme cart icon/drawer */
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'slk', data: { itemCount: cart.item_count, source: 'slk' } };
        document.dispatchEvent(ev);
        document.querySelectorAll('[data-slk-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        say('Added to cart <a href="' + root + 'cart">View cart</a>');
        return cart;
      })
      .catch(function (e) { say((e && (e.description || e.message)) || 'Sorry, that item could not be added.'); throw e; });
  }
  window.slkAdd = addItems;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-slk-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    addItems([{ id: Number(b.getAttribute('data-slk-add')), quantity: 1 }])
      .then(function () { b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1800); })
      .catch(function () {})
      .finally(function () { b.disabled = false; });
  });

  /* Reveal on scroll */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.slk-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) { el.style.transitionDelay = Math.min(i % 6, 5) * 70 + 'ms'; io.observe(el); });
  }

  /* Tabs + rail arrows */
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-slk-tabs]').forEach(function (wrap) {
      if (wrap._slk) return; wrap._slk = 1;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          wrap.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
        });
      });
      wrap.querySelectorAll('[data-slk-rail-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = wrap.querySelector('[role="tabpanel"]:not([hidden])') || wrap.querySelector('.slk-rail');
          if (panel) panel.scrollBy({ left: Number(btn.getAttribute('data-slk-rail-dir')) * panel.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Flavor switcher */
  function initFlavor(scope) {
    (scope || document).querySelectorAll('[data-slk-flavor]').forEach(function (sec) {
      if (sec._slk) return; sec._slk = 1;
      var chips = sec.querySelectorAll('[data-flavor]');
      var img = sec.querySelector('[data-fl-img]'), name = sec.querySelector('[data-fl-name]'), price = sec.querySelector('[data-fl-price]'),
          add = sec.querySelector('[data-fl-add]'), link = sec.querySelector('[data-fl-link]'), desc = sec.querySelector('[data-fl-desc]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var d = JSON.parse(c.getAttribute('data-flavor'));
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          sec.style.setProperty('--fl', d.color);
          if (img) {
            img.classList.add('is-out');
            setTimeout(function () { img.src = d.img; img.alt = d.title; img.classList.remove('is-out'); }, reduce ? 0 : 260);
          }
          if (name) name.textContent = d.name;
          if (price) price.textContent = d.price;
          if (desc) desc.textContent = d.tagline || '';
          if (add) { add.setAttribute('data-slk-add', d.variant); add.disabled = !d.available; add.textContent = d.available ? add.getAttribute('data-label') : 'Sold out'; }
          if (link) link.href = d.url;
        });
      });
    });
  }

  /* Stack builder */
  function initStack(scope) {
    (scope || document).querySelectorAll('[data-slk-stack]').forEach(function (sec) {
      if (sec._slk) return; sec._slk = 1;
      var max = Number(sec.getAttribute('data-max') || 3), pct = Number(sec.getAttribute('data-pct') || 0), code = sec.getAttribute('data-code') || '';
      var picks = sec.querySelectorAll('.slk-pick'), slots = sec.querySelectorAll('.slk-slot');
      var sub = sec.querySelector('[data-st-sub]'), save = sec.querySelector('[data-st-save]'), tot = sec.querySelector('[data-st-total]'), btn = sec.querySelector('[data-st-add]'), hint = sec.querySelector('[data-st-hint]');
      var chosen = [];
      function render() {
        slots.forEach(function (s, i) { var p = chosen[i]; s.innerHTML = p ? '<img src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '">' : '+'; });
        var cents = chosen.reduce(function (a, p) { return a + p.price; }, 0);
        var off = (pct && chosen.length >= max) ? Math.round(cents * pct / 100) : 0;
        if (sub) sub.textContent = money(cents);
        if (save) { save.parentElement.hidden = !pct; save.textContent = off ? '−' + money(off) : 'Add ' + Math.max(max - chosen.length, 0) + ' more'; }
        if (tot) tot.textContent = money(cents - off);
        if (btn) btn.disabled = chosen.length === 0;
        if (hint) hint.textContent = chosen.length >= max ? 'Your stack is full. Tap a product to swap it.' : 'Pick ' + (max - chosen.length) + ' more';
      }
      picks.forEach(function (p) {
        p.addEventListener('click', function () {
          var d = JSON.parse(p.getAttribute('data-p'));
          var idx = chosen.findIndex(function (x) { return x.variant === d.variant; });
          if (idx > -1) { chosen.splice(idx, 1); p.setAttribute('aria-pressed', 'false'); }
          else {
            if (chosen.length >= max) { var gone = chosen.shift(); sec.querySelector('.slk-pick[data-v="' + gone.variant + '"]').setAttribute('aria-pressed', 'false'); }
            chosen.push(d); p.setAttribute('aria-pressed', 'true');
          }
          render();
        });
      });
      if (btn) btn.addEventListener('click', function () {
        btn.disabled = true;
        addItems(chosen.map(function (p) { return { id: p.variant, quantity: 1 }; })).then(function () {
          if (code && chosen.length >= max) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
        }).catch(function () {}).finally(function () { btn.disabled = false; });
      });
      render();
    });
  }

  /* Quiz */
  function initQuiz(scope) {
    (scope || document).querySelectorAll('[data-slk-quiz]').forEach(function (q) {
      if (q._slk) return; q._slk = 1;
      var data = JSON.parse(q.querySelector('[data-quiz-data]').textContent);
      var steps = q.querySelectorAll('.slk-quiz__step'), bar = q.querySelector('.slk-quiz__progress i');
      var ans = {}, cur = 0;
      function show(i) {
        cur = i; steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        if (bar) bar.style.width = Math.round((i / (steps.length - 1)) * 100) + '%';
        var back = q.querySelector('.slk-quiz__back'); if (back) back.hidden = i === 0 || i === steps.length - 1;
      }
      q.addEventListener('click', function (e) {
        var o = e.target.closest('.slk-opt'); if (o && q.contains(o)) {
          var step = o.closest('.slk-quiz__step'), key = step.getAttribute('data-key');
          step.querySelectorAll('.slk-opt').forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
          ans[key] = o.getAttribute('data-val');
          setTimeout(function () { if (cur < steps.length - 2) show(cur + 1); else { result(); show(steps.length - 1); } }, reduce ? 0 : 220);
        }
        if (e.target.closest('.slk-quiz__back')) show(Math.max(cur - 1, 0));
        if (e.target.closest('[data-quiz-restart]')) { ans = {}; q.querySelectorAll('.slk-opt').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); show(0); }
      });
      function score(p) {
        var s = 0, t = (p.title + ' ' + p.type).toLowerCase();
        var f = ans.format;
        if (f && f !== 'any') {
          var map = { powder: /powder|mix|scoop|serving|lb|oz/, capsule: /caps|capsule|tablet|softgel|ct\b/, gummy: /gumm/, drink: /drops|strip|coffee|liquid|fl oz/ };
          if (map[f] && map[f].test(t)) s += 3;
        }
        var stim = /caffeine|pre-workout|pre workout|energy|ignitex|espresso|coffee|burn/.test(t);
        if (ans.caffeine === 'no' && stim) s -= 4;
        if (ans.caffeine === 'yes' && stim) s += 1;
        if (ans.level === 'new' && /stack|extreme|max|ultra/.test(t)) s -= 1;
        if (!p.available) s -= 10;
        return s + (p.rank || 0);
      }
      function result() {
        var goal = data.goals[ans.goal] || data.goals[Object.keys(data.goals)[0]];
        var list = (goal.products || []).map(function (p, i) { p.rank = (goal.products.length - i) / goal.products.length; return p; })
          .sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);
        var out = q.querySelector('[data-quiz-results]'), total = 0;
        out.innerHTML = list.map(function (p) {
          total += p.price;
          return '<div class="slk-qr"><img src="' + p.img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"><div><a href="' + p.url + '">' + p.title + '</a><small>' + money(p.price) + '</small></div>' +
            '<button class="slk-add" type="button" data-slk-add="' + p.variant + '" aria-label="Add ' + p.title.replace(/"/g, '&quot;') + ' to cart"' + (p.available ? '' : ' disabled') + '><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 5v14M5 12h14"/></svg></button></div>';
        }).join('');
        q.querySelector('[data-quiz-goal]').textContent = goal.label;
        q.querySelector('[data-quiz-total]').textContent = money(total);
        var link = q.querySelector('[data-quiz-goal-link]'); if (link) link.href = goal.url;
        var tag = q.querySelector('[data-quiz-tag]'); if (tag) tag.value = 'newsletter,quiz-' + (ans.goal || 'general');
        var all = q.querySelector('[data-quiz-addall]');
        all.onclick = function () { all.disabled = true; addItems(list.filter(function (p) { return p.available; }).map(function (p) { return { id: p.variant, quantity: 1 }; })).catch(function () {}).finally(function () { all.disabled = false; }); };
        try { sessionStorage.setItem('slkQuiz', JSON.stringify(ans)); } catch (e) {}
      }
      show(0);
    });
  }

  /* COA lookup */
  function initCoa(scope) {
    (scope || document).querySelectorAll('[data-slk-coa]').forEach(function (w) {
      if (w._slk) return; w._slk = 1;
      var sel = w.querySelector('select'), out = w.querySelector('.slk-coa__out'), mail = w.getAttribute('data-email');
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex]; if (!o.value) return;
        var coa = o.getAttribute('data-coa'), t = o.textContent.trim();
        out.innerHTML = coa ? '<strong>' + t + '</strong><br><a href="' + coa + '" target="_blank" rel="noopener">View Certificate of Analysis</a>'
          : '<strong>' + t + '</strong><br>Request the latest batch certificate and we will email it to you. <a href="mailto:' + mail + '?subject=' + encodeURIComponent('COA request: ' + t) + '">Request COA</a>';
      });
    });
  }

  /* Related products via Section Rendering API */
  function initRelated(scope) {
    (scope || document).querySelectorAll('[data-slk-related]').forEach(function (el) {
      if (el._slk) return; el._slk = 1;
      var url = el.getAttribute('data-url');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-slk-related]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initRails(el); initReveal(el); }
        else { el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true); }
      }).catch(function () {});
    });
  }

  function initAll(scope) { initReveal(scope); initRails(scope); initFlavor(scope); initStack(scope); initQuiz(scope); initCoa(scope); initRelated(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
